import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/app/src/app/providers.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/styles/globals.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"300\",\"400\",\"500\",\"600\",\"700\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/CheckSentry.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/GMsgToastSubscriber.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/I18nProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OrientationSuggestion"] */ "/app/src/components/OrientationSuggestion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OrientationSuggestionWrapper"] */ "/app/src/components/OrientationSuggestionWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ServicesLoader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Tour/TourClientProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/src/components/ui/sonner.tsx");
